import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
} from "reactstrap";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";
import Shimmer from "react-shimmer-effect";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../../services/apiResponse";

import UpdateBloc from "./Blocs/UpdateBloc";
// import PegawaiSideBar from '../../../GlobalComponents/PegawaiSidebar'

import { accessRole } from "../../../../../helpers/access_role";

let peg_uuid =
  JSON.parse(localStorage.getItem("userdata")) != null
    ? JSON.parse(localStorage.getItem("userdata")).employee_uuid
    : "";
if (accessRole("approve")) {
  peg_uuid =
    JSON.parse(localStorage.getItem("employeeSelected")) != null
      ? JSON.parse(localStorage.getItem("employeeSelected")).employee_uuid
      : "";
}

var reformatOptionPosition = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] = region.position_name;
    newObj["value"] = region.position_uuid;

    return newObj;
  });
};

var reformatOptionEchelon = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] = region.echelon_name;
    newObj["value"] = region.echelon_uuid;

    return newObj;
  });
};

var reformatOptionPositonStatus = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] = region.position_status_name;
    newObj["value"] = region.position_status_uuid;

    return newObj;
  });
};

var reformatOptionWorkUnit = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] = region.work_unit_name;
    newObj["value"] = region.work_unit_uuid;
    return newObj;
  });
};

var reformatOptionSignatoryOfficial = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] = region.signatories_official_name;
    newObj["value"] = region.signatories_official_name;
    return newObj;
  });
};

class IndexView extends Component {
  updateBloc = new UpdateBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      positionItems: [],
      PositionSelected: "",
      echelonItems: [],
      echelonSelected: "",
      positionStatusItems: [],
      PositionStatusSelected: "",
      workUnitFormItems: [],
      workUnitFormSelected: "",
      workUnitToItems: [],
      workUnitToSelected: "",
      signantoryItems: [],
      signatorySelected: "",
      emp_jabatan: "",
      primary_credit: 0,
    };
  }

  submitData = async () => {
    await this.updateBloc.fetchUpdate(this.state.dataForm);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        employee_uuid: peg_uuid,
        ...values,
      },
      confirm: true,
    });
  };

  onChangePosition = (PositionSelected) => {
    this.setState({
      PositionSelected: PositionSelected.value,
    });
  };

  onChangeEchelon = (echelonSelected) => {
    this.setState({
      echelonSelected: echelonSelected.value,
    });
  };

  onChangePositionStatus = (PositionStatusSelected) => {
    this.setState({
      PositionStatusSelected: PositionStatusSelected.value,
    });
  };

  onChangeWorkUnitForm = (workUnitFormSelected) => {
    this.setState({
      workUnitFormSelected: workUnitFormSelected.value,
    });
  };

  onChangeWorkUnitTo = (workUnitToSelected) => {
    this.setState({
      workUnitToSelected: workUnitToSelected.value,
    });
  };

  onChangeSignatory = (signatorySelected) => {
    this.setState({
      signatorySelected: signatorySelected.value,
    });
  };
  download_file = () => {
    window.open(this.state.dataForm.document.documents_path, "_blank");
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.updateBloc.updateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.updateBloc.positionChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              positionItems: reformatOptionPosition(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.updateBloc.echelonChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              echelonItems: reformatOptionEchelon(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.updateBloc.positionStatusChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              positionStatusItems: reformatOptionPositonStatus(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.updateBloc.workUnitChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            // console.log(response)

            this.setState({
              workUnitFormItems: reformatOptionWorkUnit(response.result),
              workUnitToItems: reformatOptionWorkUnit(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.updateBloc.signatoryChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            console.log(response);

            this.setState({
              signantoryItems: reformatOptionSignatoryOfficial(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    // this.updateBloc.detailChannel.subscribe((result) => {
    //     switch (result.status) {
    //         case apiResponse.COMPLETED:
    //             if(result.data.status) {
    //                 let response = result.data.response
    //                 // load to form
    //                 this.setState({
    //                     dataForm: {
    //                       uuid: response.credit_score_uuid,
    //                       employee_uuid: response.credit_score_employee_uuid,
    //                       no_sk: response.credit_score_decree_number,
    //                       tanggal_sk: response.credit_score_decree_date,
    //                       start_month: response.credit_score_month_start,
    //                       end_month: response.credit_score_month_end,
    //                       start_year: response.credit_score_year_start,
    //                       end_year: response.credit_score_year_end,
    //                       secondary_credit: response.credit_score_secondary,
    //                       primary_credit: response.credit_score_primary,
    //                       total_credit: response.credit_score_total,
    //                     },
    //                     PositionSelected: response.credit_score_position_uuid,
    //                     emp_jabatan: response.employee_current_position_name,
    //                     primary_credit: response.credit_score_primary,
    //                     // echelonSelected:  response.position_history_echelon_uuid,
    //                     // PositionStatusSelected:  response.position_history_position_status_uuid,
    //                     // workUnitFormSelected:  response.position_history_work_unit_uuid_from,
    //                     // workUnitToSelected:  response.position_history_work_unit_uuid_to,
    //                     // signatorySelected:  response.position_history_signatories_official,
    //                 })

    //             }
    //             break
    //         case apiResponse.ERROR:

    //             break
    //         default:
    //             break
    //     }
    // })

    this.updateBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingDetail: true,
          });

        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            // this.createBloc.fetchEmployee({
            //   uuid: response.credit_score_employee_uuid,
            // });
            // load to form
            console.log(response);
            debugger;
            this.setState({
              //   dataForm: response,
              dataForm: {
                uuid: response.credit_score_uuid,
                employee_uuid: response.credit_score_employee_uuid,
                no_sk: response.credit_score_decree_number,
                tanggal_sk: response.credit_score_decree_date,
                start_month: response.credit_score_month_start,
                end_month: response.credit_score_month_end,
                start_year: response.credit_score_year_start,
                end_year: response.credit_score_year_end,
                secondary_credit: response.credit_score_secondary,
                primary_credit: response.credit_score_primary,
                total_credit: response.credit_score_total,
                employee_current_position_name:
                  response.employee_current_position_name,
                employee_full_name: response.employee_full_name,
                document: response.document,
              },
              loadingDetail: false,
              //   //   PositionSelected: response.credit_score_position_uuid,
              //   totcredit: response.credit_score_secondary,
              //   totcredit2: response.credit_score_primary,
              // echelonSelected:  response.position_history_echelon_uuid,
              // PositionStatusSelected:  response.position_history_position_status_uuid,
              // workUnitFormSelected:  response.position_history_work_unit_uuid_from,
              // workUnitToSelected:  response.position_history_work_unit_uuid_to,
              // signatorySelected:  response.position_history_signatories_official,
            });
            console.log(this.state.dataForm);
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    const search = window.location.search;
    const queryParams = new URLSearchParams(search);
    this.updateBloc.fetchDetail({ uuid: queryParams.get("uuid") });

    // this.updateBloc.fetchPosition()
    // this.updateBloc.fetchEchelon()
    // this.updateBloc.fetchPositionStatus()
    // this.updateBloc.fetchWorkUnit()
    // this.updateBloc.fetchSignatory()
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              {/* <PegawaiSideBar active="riwayatjabatan"/> */}

              <Card className="">
                <CardBody>
                  <CardTitle>Approve Riwayat Angka Kredit</CardTitle>
                  {/* <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle> */}
                  <hr />

                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <AvField
                      name="uuid"
                      type="hidden"
                      id="uuid"
                      value={this.state.dataForm.uuid}
                    />
                    <AvField
                      name="employee_uuid"
                      type="hidden"
                      id="employee_uuid"
                      value={this.state.dataForm.employee_uuid}
                    />

                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-3 col-form-label">
                        Nama
                      </label>
                      <Col md="5">
                        <AvField
                          name="employee_full_name"
                          type="text"
                          className="form-control"
                          id="employee_full_name"
                          value={this.state.dataForm.employee_full_name}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-3 col-form-label">
                        Jabatan
                      </label>
                      <Col md="5">
                        <AvField
                          name="jabatan"
                          type="text"
                          className="form-control"
                          id="jabatan"
                          value={
                            this.state.dataForm.employee_current_position_name
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    {/* <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            No SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="no_sk"
                                                    placeholder="Nomor SK..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor SK"
                                                    className="form-control"
                                                    id="no_sk"
                                                    value={this.state.dataForm.no_sk}
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row> */}
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        No SK <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="no_sk"
                          placeholder="Nomor SK..."
                          type="text"
                          errorMessage="Masukkan Nomor SK"
                          className="form-control"
                          id="no_sk"
                          value={this.state.dataForm.no_sk}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-3 col-form-label">
                        Tanggal SK <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="tanggal_sk"
                          placeholder="Tanggal SK..."
                          type="date"
                          errorMessage="Masukkan Tanggal SK"
                          className="form-control"
                          id="tanggal_sk"
                          value={this.state.dataForm.tanggal_sk}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-3 col-form-label">
                        Bulan Mulai Penilaian{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="start_month"
                          placeholder=" Bulan Mulai Penilaian..."
                          type="number"
                          errorMessage="Masukkan Bulan Mulai Penilaian"
                          className="form-control"
                          id="start_month"
                          value={this.state.dataForm.start_month}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-3 col-form-label">
                        Bulan Selesai Penilaian{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="end_month"
                          placeholder=" Bulan Selesai Penilaian..."
                          type="number"
                          errorMessage="Masukkan Bulan Selesai Penilaian"
                          className="form-control"
                          id="end_month"
                          value={this.state.dataForm.end_month}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-3 col-form-label">
                        Tahun Mulai Penilaian{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="start_year"
                          placeholder=" Tahun Mulai Penilaian..."
                          type="number"
                          errorMessage="Masukkan Tahun Mulai Penilaian"
                          className="form-control"
                          id="start_year"
                          value={this.state.dataForm.start_year}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-3 col-form-label">
                        Tahun Selesai Penilaian{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="end_year"
                          placeholder=" Tahun Selesai Penilaian..."
                          type="number"
                          errorMessage="Masukkan Tahun Selesai Penilaian"
                          className="form-control"
                          id="end_year"
                          value={this.state.dataForm.end_year}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    {/* <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jabatan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <Select
                                                    value={this.state.positionItems.filter(option => 
                                                      option.value === this.state.PositionSelected)}
                                                    onChange={
                                                      this.onChangePosition
                                                    }
                                                    required="required"
                                                    options={this.state.positionItems}
                                                    classNamePrefix=""
                                                />

                                                <AvField
                                                    name="position_id"
                                                    placeholder="Nama Jabatan..."
                                                    type="hidden"
                                                    errorMessage="Masukkan Nama Jabatan"
                                                    className="form-control"
                                                    id="position_id"
                                                    value={this.state.PositionSelected}
                                                />
                                            </Col>
                                        </Row> */}
                    {/* <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jabatan 
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="jabatan"
                                                    type="text"
                                                    className="form-control"
                                                    id="jabatan"
                                                    value={this.state.emp_jabatan}
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row> */}

                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-3 col-form-label">
                        Kredit Penunjang Baru{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="secondary_credit"
                          placeholder=" Kredit Penunjang Baru..."
                          type="number"
                          errorMessage="Masukkan Kredit Penunjang Baru"
                          className="form-control"
                          id="secondary_credit"
                          value={this.state.dataForm.secondary_credit}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-3 col-form-label">
                        Kredit Utama Baru <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="primary_credit"
                          placeholder=" Kredit Utama Baru..."
                          type="number"
                          errorMessage="Masukkan Kredit Utama Baru"
                          className="form-control"
                          id="primary_credit"
                          value={this.state.dataForm.primary_credit}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-3 col-form-label">
                        Total Kredit Baru <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="total_credit"
                          placeholder=" Total Kredit Baru..."
                          type="number"
                          errorMessage="Masukkan Total Kredit Baru"
                          className="form-control"
                          id="total_credit"
                          value={this.state.dataForm.total_credit}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3">Dokumen SK</label>
                      <Col md="9">
                        {this.state.loadingDetail === false ? (
                          <>
                            {this.state.dataForm &&
                            this.state.dataForm.document !== null ? (
                              // <a
                              //   target={"_blank"}
                              //   className="btn btn-sm btn-success"
                              //   href={
                              //     this.state.dataForm.document.documents_path
                              //   }
                              // >
                              //   Download <i className="fa fa-download ms-1"></i>
                              // </a>
                              <Button
                                className="btn btn-sm btn-success"
                                onClick={() => {
                                  this.download_file();
                                }}
                              >
                                Download <i className="fa fa-download ms-1"></i>
                              </Button>
                            ) : (
                              "-"
                            )}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "30%", height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Status Approval <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <Select
                          name="statusslc"
                          type="text"
                          options={[
                            { value: 2, label: "Disetujui" },
                            { value: 0, label: "Ditolak" },
                          ]}
                          onChange={(opt) =>
                            this.setState({ statusApproval: opt.value })
                          }
                          defaultValue={this.state.statusApproval}
                          className="form-control"
                          validate={{ required: { value: true } }}
                          required={true}
                        />

                        <AvField
                          name="status"
                          type="hidden"
                          className="form-control"
                          id="position_id"
                          value={this.state.statusApproval}
                        />
                      </Col>
                    </Row>

                    {this.state.statusApproval != 2 && (
                      <Row className="mb-3">
                        <label className="col-md-3 col-form-label">
                          Catatan
                        </label>
                        <Col md="5">
                          <AvField
                            name="approval_note"
                            placeholder="Catatan"
                            errorMessage="Masukkan Catatan"
                            type="textarea"
                            className="form-control"
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </Row>
                    )}

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="/kepegawaian/riwayat_angkakredit.html">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/riwayat_angkakredit.html" />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
